import 'svelte/internal/disclose-version';

Bubble[$.FILENAME] = 'client/lib/Bubble.svelte';

import * as $ from 'svelte/internal/client';

var root = $.add_locations(
	$.from_html(
		`

<div>
  <svg class="absolute inset-0 h-full w-full overflow-visible" aria-hidden="true">
    <polygon fill="#fff" stroke="#17150f" stroke-width="4.5" stroke-linejoin="round"></polygon>
  </svg>
  <div class="absolute inset-x-0 top-0 font-comic leading-tight tracking-wide">
    <div class="h-full overflow-hidden text-center">
      <div class="float-left h-full w-1/2"></div>
      <div class="float-right h-full w-1/2"></div>
      <!>
    </div>
  </div>
</div>`,
		1
	),
	Bubble[$.FILENAME],
	[
		[
			76,
			0,
			[[77, 2, [[78, 4]]], [80, 2, [[81, 4, [[82, 6], [83, 6]]]]]]
		]
	]
);

function Bubble($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Bubble);

	let big = $.prop($$props, 'big', 19, () => -1),
		seed = $.prop($$props, 'seed', 3, 1),
		cls = $.prop($$props, 'class', 3, "");

	let w = $.tag($.state(0), 'w');
	let h = $.tag($.state(0), 'h');
	const m = 22;

	const rnd = (i) => {
		const x = Math.sin(i * 12.9898 + seed() * 78.233) * 43758.5453;

		return x - Math.floor(x);
	};

	const wobble = (a) => 1 + 0.025 * Math.sin(2 * a + seed()) + 0.02 * Math.sin(3 * a + seed() * 2.7);

	const points = $.tag(
		$.derived(() => {
			const rx = $.get(w) / 2 - m, ry = $.get(h) / 2 - m;

			if (rx <= 0 || ry <= 0) return "";

			const S = 720, cum = [0];

			for (let i = 1; i <= S; i++) {
				const a0 = (i - 1) / S * Math.PI * 2,
					a1 = i / S * Math.PI * 2;

				cum.push(cum[i - 1] + Math.hypot(rx * (Math.cos(a1) - Math.cos(a0)), ry * (Math.sin(a1) - Math.sin(a0))));
			}

			const P = cum[S], n = Math.round(P / 44);

			const at = (t) => {
				let i = 0;

				while (cum[i + 1] < t) i++;

				const a = (i + (t - cum[i]) / (cum[i + 1] - cum[i])) / S * Math.PI * 2;

				const nx = Math.cos(a) * ry,
					ny = Math.sin(a) * rx,
					l = Math.hypot(nx, ny),
					k = wobble(a);

				return [
					$.get(w) / 2 + Math.cos(a) * rx * k,
					$.get(h) / 2 + Math.sin(a) * ry * k,
					nx / l,
					ny / l
				];
			};

			const out = [];

			for (let i = 0; i < n; i++) {
				const [x, y, nx, ny] = at((i + (rnd(i + 100) - 0.5) * 0.3) / n * P),
					len = $.strict_equals(i, Math.round(big() * n)) ? 52 : 10 + rnd(i) * 8;

				out.push(`${x + nx * len},${y + ny * len}`);

				const [x2, y2, nx2, ny2] = at((i + 0.5 + (rnd(i + 200) - 0.5) * 0.2) / n * P),
					dip = 1 + rnd(i + 300) * 2;

				out.push(`${x2 - nx2 * dip},${y2 - ny2 * dip}`);
			}

			return out.join(" ");
		}),
		'points'
	);

	const half = (side) => {
		const pts = [side > 0 ? "0% 0%" : "100% 0%"];

		for (let i = 0; i <= 40; i++) {
			const a = -Math.PI / 2 - side * (Math.PI * i) / 40,
				k = wobble(a) - 0.09;

			pts.push(`${(side > 0 ? 100 : 0) + Math.cos(a) * 100 * k}% ${50 + Math.sin(a) * 50 * k}%`);
		}

		pts.push(side > 0 ? "0% 100%" : "100% 100%");

		return `polygon(${pts.join(",")})`;
	};

	function fit(node) {
		const text = node.firstElementChild;
		let last = "";

		const run = () => {
			const key = `${node.clientWidth}:${document.fonts.status}`;

			if ($.strict_equals(key, last)) return;

			last = key;
			$.set(w, node.clientWidth, true);
			text.style.paddingTop = "0px";

			for (let H = 60; H < 2000; H += 6) {
				$.set(h, H, true);
				node.style.height = `${H - 2 * m}px`;

				if (text.scrollHeight <= text.clientHeight + 1 && text.scrollWidth <= text.clientWidth + 1) break;
			}

			const range = document.createRange();

			range.selectNodeContents(text);

			const rects = [...range.getClientRects()].filter((r) => r.width > 0 && r.height > 0);
			const box = text.getBoundingClientRect();

			const top = Math.min(...rects.map((r) => r.top)) - box.top,
				bottom = box.bottom - Math.max(...rects.map((r) => r.bottom));

			text.style.paddingTop = `${Math.max(0, (bottom - top) / 2)}px`;
		};

		run();
		document.fonts.ready.then(run);

		const ro = new ResizeObserver(() => run());

		ro.observe(node.parentElement);

		return () => ro.disconnect();
	}

	var $$exports = { ...$.legacy_api() };

	$.next();

	var fragment = root();
	var div = $.sibling($.first_child(fragment));
	var svg = $.sibling($.child(div));
	var polygon = $.sibling($.child(svg));

	$.next();
	$.reset(svg);

	var div_1 = $.sibling(svg, 2);

	$.set_style(div_1, 'margin: 22px 0');

	var div_2 = $.sibling($.child(div_1));
	var div_3 = $.sibling($.child(div_2));
	var div_4 = $.sibling(div_3, 2);
	var node_1 = $.sibling(div_4, 2);

	$.add_svelte_meta(() => $.snippet(node_1, () => $$props.children), 'render', Bubble, 84, 6);
	$.next();
	$.reset(div_2);
	$.next();
	$.reset(div_1);
	$.action(div_1, ($$node) => fit?.($$node));
	$.next();
	$.reset(div);

	$.template_effect(
		($0, $1) => {
			$.set_class(div, 1, `relative ${cls() ?? ''}`);
			$.set_style(div, `height: ${$.get(h) ?? ''}px`);
			$.set_attribute(svg, 'viewBox', `0 0 ${$.get(w) ?? ''} ${$.get(h) ?? ''}`);
			$.set_attribute(polygon, 'points', $.get(points));
			$.set_style(div_3, `shape-outside: ${$0 ?? ''}`);
			$.set_style(div_4, `shape-outside: ${$1 ?? ''}`);
		},
		[() => half(1), () => half(-1)]
	);

	$.append($$anchor, fragment);

	return $.pop($$exports);
}

if (import.meta.hot) {
	Bubble = $.hmr(Bubble);

	import.meta.hot.accept((module) => {
		Bubble[$.HMR].update(module.default);
	});
}

export default Bubble;